import styled from 'styled-components';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { SegmentedControl, SegmentedControlProps } from '@mantine/core';

export const ValuationsSummaryContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	box-sizing: border-box;
	width: 100%;
	gap: 8px;
	padding: 0px;
`;

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow: auto;
	border-bottom-right-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
	border-top: none;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	margin-top: 8px;
`;

export const ControlsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem;
	background-color: ${({ theme }) => theme.color.greys[50]};
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	flex-shrink: 0;
`;

export const TableSwitch = styled(SegmentedControl)<SegmentedControlProps>`
	background-color: ${({ theme }) => theme.color.white[500]};
	border: 1px solid ${({ theme }) => theme.color.greys[200]};

	.mantine-SegmentedControl-label {
		color: ${({ theme }) => theme.v3.colors.dark[8]} !important;
		line-height: 21px;
		font-weight: 500;
	}

	.mantine-SegmentedControl-innerLabel {
		white-space: nowrap;
	}

	.mantine-SegmentedControl-indicator {
		background-color: ${({ theme }) => theme.v3.colors.blue[0]};
		border: 1px solid ${({ theme }) => theme.v3.colors.blue[6]};
	}
`;

export const ValuationDateContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const ValuationDateLabel = styled(TextV2)`
	color: ${({ theme }) => theme.v3.colors.gray[9]};
`;

export const ValuationDateValue = styled(TextV2)`
	color: ${({ theme }) => theme.v3.colors.dark[9]};
`;

export const LeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const RightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;
